<template>
  <v-container class="pa-0">
    <v-toolbar flat>
      <v-toolbar-title>
        Cards
      </v-toolbar-title>
      <v-spacer />
      <customer-card-create-dialog
        :is-platform="isPlatform"
        :customer-id="customerId"
        @action="reloadTable()"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            v-on="on"
          >
            <v-icon>add</v-icon>
            Add Card
          </v-btn>
        </template>
      </customer-card-create-dialog>
    </v-toolbar>

    <base-stripe-table
      v-if="customerId"
      ref="cardTable"
      :headers="headers"
      :fetch-action="'listCustomerPaymentMethods'"
      :fetch-query="{ customer: customerId }"
      :fetch-headers="isPlatform ? { 'x-account': '' } : {}"
      :items-getter="'getCustomerPaymentMethods'"
      :pagination-getter="'getCustomerPaymentMethodsPagination'"
      :show-expand="true"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <template v-for="item in items">
            <tr
              :key="`${item.id}`"
            >
              <td @click="toggleExpand(item.id)">
                <v-icon v-if="expandedMap[item.id]">
                  keyboard_arrow_down
                </v-icon>
                <v-icon v-if="!expandedMap[item.id]">
                  keyboard_arrow_up
                </v-icon>
              </td>
              <td>
                {{ item.card.brand }} **** {{ item.card.last4 }} <br/>
                <span class="grey--text">{{ item.card.exp_month }} / {{ item.card.exp_year }}</span>
              </td>
              <td class="text-right">
                <v-chip
                  v-if="defaultCard === item.id"
                  outlined
                  small
                  color="info"
                  class="mr-5"
                >
                  Default
                </v-chip>
                <v-progress-circular
                  v-if="isLoadingMap[item.id] === true"
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                />
                <v-menu
                  v-if="isLoadingMap[item.id] !== true"
                  left
                >
                  <template v-slot:activator="{ on}">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense>
                    <customer-card-update-dialog
                      :is-platform="isPlatform"
                      :id="item.id"
                      :customer-id="customerId"
                      @action="reloadTable()"
                    >
                      <template v-slot:activator="{ on }">
                        <v-list-item
                          v-on="on"
                          @click.stop=""
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-icon
                                left
                                small
                              >
                                edit
                              </v-icon>
                              Edit
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </customer-card-update-dialog>

                    <v-list-item
                      @click="setDefaultPaymentMethod(item.id)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon
                            left
                            small
                          >
                            stars
                          </v-icon>
                          Set as default
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <customer-card-delete-dialog
                      :is-platform="isPlatform"
                      :id="item.id"
                      :customer="customerId"
                      @action="reloadTable()"
                    >
                      <template v-slot:activator="{ on }">
                        <v-list-item
                          v-on="on"
                          @click.stop=""
                        >
                          <v-list-item-content>
                            <v-list-item-title class="error--text">
                              <v-icon
                                left
                                small
                                color="error"
                              >
                                delete
                              </v-icon>
                              Delete
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </customer-card-delete-dialog>
                  </v-list>
                </v-menu>
              </td>
            </tr>
            <tr v-if="expandedMap[item.id]">
              <td :colspan="headers.length + 1">
                <info-list
                  :list="[
                          {
                            label: 'Name',
                            value: item.billing_details.name
                          },
                          {
                            label: 'Last 4 digits',
                            value: `**** ${item.card.last4}`
                          },
                          {
                            label: 'Expires',
                            value: `${item.card.exp_month} / ${item.card.exp_year}`
                          },
                          {
                            label: 'Brand',
                            value: item.card.brand
                          },
                          {
                            label: 'Billing Address',
                            value: [
                              item.billing_details.address.line1,
                              item.billing_details.address.line2,
                              `${item.billing_details.address.city}, ${item.billing_details.address.state}, ${item.billing_details.address.postal_code} `,
                              item.billing_details.address.country
                            ]
                          },
                          {
                            label: 'CVC Check',
                            value: item.card.checks.cvc_check
                          },
                          {
                            label: 'Street Check',
                            value: item.card.checks.address_line1_check
                          },
                          {
                            label: 'Postal Code Check',
                            value: item.card.address_postal_code_check
                          },
                        ]"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </base-stripe-table>
  </v-container>

</template>
<script>
import { mapActions } from 'vuex'
import BaseStripeTable from '@/components/Common/BaseStripeTable'
import CustomerCardCreateDialog from '@/components/Customer/CustomerCardCreateDialog'
import CustomerCardDeleteDialog from '@/components/Customer/CustomerCardDeleteDialog'
import CustomerCardUpdateDialog from '@/components/Customer/CustomerCardUpdateDialog'
import InfoList from "../Common/InfoList"

export default {
  components: {
    InfoList,
    CustomerCardDeleteDialog,
    BaseStripeTable,
    CustomerCardCreateDialog,
    CustomerCardUpdateDialog,
  },
  props: {
    isPlatform: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: String,
      default: ''
    },
    defaultSource: {
      type: String,
      default: ''
    }
  },
  watch: {
    'defaultSource'() {
      this.defaultCard = this.defaultSource
    }
  },
  data() {
    return {
      isLoadingMap: {},
      expandedMap: {},
      defaultCard: this.defaultSource,
      headers: [
        {
          text: 'Card details',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Actions',
          align: 'right',
          sortable: false,
        },
      ]
    }
  },
  methods: {
    ...mapActions([ 'updateCustomer' ]),
    async setDefaultPaymentMethod(sourceId) {
      const payload = {
        id: this.customerId,
        invoice_settings: {
          default_payment_method: sourceId
        }
      }

      if (this.isPlatform) {
        payload._headers = { 'x-account': '' }
      }

      this.setIsLoadingMap(sourceId, true)
      const customer = await this.updateCustomer(payload)
      this.setIsLoadingMap(sourceId, false)

      if (customer && customer.invoice_settings && customer.invoice_settings.default_payment_method) {
        this.defaultCard = customer.invoice_settings.default_payment_method
      }
    },
    setIsLoadingMap(id, value) {
      this.isLoadingMap = {
        ...this.isLoadingMap,
        [ id ]: !!value
      }
    },
    reloadTable() {
      this.$refs.cardTable.fetchData()
    },
    toggleExpand(id) {
      const clone = { ...this.expandedMap }

      clone[ id ] = !clone[ id ]

      this.expandedMap = clone
    }
  },
}
</script>
